import { Button, Typography } from 'antd'
import React from 'react'
import { JOURNEYS_SERVICE } from '../../../Constants'
import { SustainableEventIcon } from '../Icons'

import './SustainableEventBannerLarge.less'

const { Text } = Typography

interface SustainableEventBannerLargeProps {
  eventUUID: string
  showIcon?: boolean
}

export const SustainableEventBannerLarge = ({
  eventUUID,
  showIcon = true,
}: SustainableEventBannerLargeProps): JSX.Element => (
  <div
    style={{
      background: '#FFF',
      border: '1px solid #4F987B',
      borderRadius: '4px',
      paddingLeft: '24px',
    }}
  >
    <div style={{ display: 'flex' }}>
      <div
        style={{ paddingTop: '18px', paddingBottom: '18px', color: '#0E4433' }}
      >
        <div style={{ marginBottom: '8px' }}>
          <Text strong style={{ whiteSpace: 'nowrap', color: '#0E4433' }}>
            Planning a sustainable event?
          </Text>
        </div>
        <div style={{ marginBottom: '24px' }}>
          <Text style={{ color: '#0E4433' }}>
            Travel is the biggest source of carbon emissions for an in-person
            event. Add travel details for your guests to find the most
            sustainable venue options
          </Text>
        </div>
        <Button
          href={`${JOURNEYS_SERVICE}/${eventUUID}/journeys`}
          rel="noopener noreferrer"
          target="_blank"
          className='add-travel-information-button'
          style={{
            marginRight: '16px',
            color: '#FFFFFF',
            fontWeight: 600,
            fontSize: '14px',
            background: '#187759',
          }}
        >
          Add Travel Information
        </Button>
      </div>
      {showIcon ? (
        <div
          style={{
            width: '180px',
            display: 'inline-flex',
            marginRight: '12px',
            paddingTop: '4px',
          }}
        >
          <SustainableEventIcon />
        </div>
      ) : null}
    </div>
  </div>
)
